import type { DateTimeFilter, IGetCompareDateByAlias } from '~/presentation/ui';

import {
  getPreviousWeek,
  getPreviousQuarter,
  getPreviousMonth,
  getPreviousYear,
  getNoComparison,
  getPreviousPeriod,
} from '../helpers/';

export enum CompareDateTimePickerAlias {
  NO_COMPARISON = 'noComparison',
  PREVIOUS_PERIOD = 'previousPeriod',
  PREVIOUS_WEEK = 'previousWeek',
  PREVIOUS_MONTH = 'previousMonth',
  PREVIOUS_QUARTER = 'previousQuarter',
  PREVIOUS_YEAR = 'previousYear',
}

export const PREVIOUS_PERIOD_FILTER: DateTimeFilter = {
  title: 'Previous period',
  alias: CompareDateTimePickerAlias.PREVIOUS_PERIOD,
  since: 0,
  until: 0,
};
export const DATE_TIME_COMPARISON_FILTERS: DateTimeFilter[] = [
  {
    title: 'No comparison',
    alias: CompareDateTimePickerAlias.NO_COMPARISON,
    since: 0,
    until: 0,
  },
  PREVIOUS_PERIOD_FILTER,
  {
    title: 'Previous week',
    alias: CompareDateTimePickerAlias.PREVIOUS_WEEK,
    since: 0,
    until: 0,
  },
  {
    title: 'Previous quarter',
    alias: CompareDateTimePickerAlias.PREVIOUS_QUARTER,
    since: 0,
    until: 0,
  },
  {
    title: 'Previous month',
    alias: CompareDateTimePickerAlias.PREVIOUS_MONTH,
    since: 0,
    until: 0,
  },
  {
    title: 'Previous year',
    alias: CompareDateTimePickerAlias.PREVIOUS_YEAR,
    since: 0,
    until: 0,
  },
];

export const COMPARE_DATE_TIME_FILTERS_MAP: Record<
  CompareDateTimePickerAlias,
  IGetCompareDateByAlias
> = {
  [CompareDateTimePickerAlias.NO_COMPARISON]: getNoComparison,
  [CompareDateTimePickerAlias.PREVIOUS_PERIOD]: getPreviousPeriod,
  [CompareDateTimePickerAlias.PREVIOUS_WEEK]: getPreviousWeek,
  [CompareDateTimePickerAlias.PREVIOUS_QUARTER]: getPreviousQuarter,
  [CompareDateTimePickerAlias.PREVIOUS_MONTH]: getPreviousMonth,
  [CompareDateTimePickerAlias.PREVIOUS_YEAR]: getPreviousYear,
};
